import React from "react";

const GoogleMapEmbed = () => {
  return (
    <div className="w-full  rounded-2xl overflow-hidden px-4 md:px-10 mb-8">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3745.054014926053!2d85.65296277500711!3d20.173476381270408!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19aebe60376915%3A0x5ca52f87c1f12f54!2sKALINGA%20BIO%20FERTI-CHEM%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1774604305554!5m2!1sen!2sin"
        width="100%"
        height="500"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="rounded-xl"
      />
    </div>
  );
};

export default GoogleMapEmbed;
